<template>
  <v-dialog v-model="showModal" max-width="800">
    <v-form ref="form" @submit.prevent="sendCreateInvoice">
      <v-card>
        <v-card-title>
          <h3>{{ $t('billing-request.transmit-invoice')}}</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-3">
          <v-row>
            <v-col>
              <span v-html="$t('billing-request.selected-billing-requests', {count: selectedItems.length})"></span> :
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div style="max-height: 300px; padding-top: 8px; overflow: scroll; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc">
                <v-chip class="ml-1 mb-2" :key="item.billingRequestReference" close v-for="(item, i) in selectedItems" @click:close="removeSelectedItem(i)" @click="openBillingRequest(item)">{{ item.billingRequestReference}}</v-chip>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>

              <organization-select
                  v-model="organizationId"
                  label="Organisation"
                  disabled
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              {{ $t('billing-request.expected-invoice-amount') }} :
            </v-col>
          </v-row>

          <v-data-table
              class="my-3"
              :headers="[
                { text: $tc('amount-excl-vat'), value: 'netTotal' },
                { text: $tc('amount-incl-vat'), value: 'finalTotal' },
              ]"
              :items="[{netTotal: netTotalForSelectedItems, finalTotal: finalTotalForSelectedItems}]"
              hide-default-footer
          >
            <template #item.netTotal="{value}">
              {{ numberFormat(value) }} €
            </template>
            <template #item.finalTotal="{value}">
              {{ numberFormat(value) }} €
            </template>
          </v-data-table>


        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row dense>
            <v-col class="ma-0 text-right">
              <v-btn small @click="showModal = false">{{ $t('cancel') }}</v-btn>
              <v-btn class="ml-3" :disabled="!canSend" small color="primary" type="submit">{{ $t('billing-request.prepare-invoice')}}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-form>
    <billing-request-show-modal ref="billingRequestModal" />
  </v-dialog>
</template>

<script>
import BillingRequestRepository from "@repository/BillingRequestRepository";
import OrganizationSelect from "@blocks/Select/OrganizationSelect.vue";
import RulesMixin from "@mixins/RulesMixin";
import BillingRequestShowModal from "./BillingRequestShowModal.vue";

export default {
  components: {
    BillingRequestShowModal,
    OrganizationSelect,
  },

  data() {
    return {
      organizationId: null,
      reference: null,
      invoiceFile: null,
      showModal: false,
    }
  },

  props: {
    selectedItems: Array,
  },

  mixins: [
    RulesMixin,
  ],
  mounted() {

  },

  watch: {

  },

  computed: {

    netTotalForSelectedItems() {
      return this.selectedItems.reduce((acc, item) => acc + item.netTotal, 0)
    },

    finalTotalForSelectedItems() {
      return this.selectedItems.reduce((acc, item) => acc + item.finalTotal, 0)
    },

    canSend() {
      return this.selectedItems.length > 0
    }
  },

  methods: {
    open() {
      let organizationIds = this.selectedItems.map(item => item.organizationId)
      this.organizationId = organizationIds[0] ?? null
      this.reference = null
      this.invoiceFile = null
      if(!this.organizationId) {
        this.organizationId = this.currentUser?.selectedOrganizationId ?? this.currentUser?.organizations[0] ?? null
      }
      this.showModal = true
    },

    close() {
      this.showModal = false
    },

    removeSelectedItem(index) {
      this.$dialog.confirm({text: this.$t('are-you-sure')}).then(result => {
        if (result) {
          this.selectedItems.splice(index, 1)
          if(this.selectedItems.length === 0) {
            this.close()
          }
        }
      })
    },

    openBillingRequest(billingRequest) {
      this.$refs.billingRequestModal.open(billingRequest.id)
    },


    sendCreateInvoice() {
      if(this.$refs.form.validate()) {
        this.showLoading(true)
        BillingRequestRepository.createBillingDetailInvoice(
            this.organizationId,
            this.reference,
            this.selectedItems.map(item => item.id),
            this.invoiceFile,
        ).then(data => {
          this.showLoading(false)
          this.close()
          this.$emit('updated')
          this.$router.push({name: 'billing-requests.invoices.edit', params: {id: data.id}})
        }).catch(err => {
          this.notifyError(err)
          this.showLoading(false)
        })
      }

    }
  }
}
</script>



<style lang="scss">

</style>